import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";

/**
 * @purpose Edit one material's data and price
 * @primary Material form
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/materials/$id/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
